// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Env from "../core/Env.res.js";
import * as React from "react";
import * as History from "history";
import * as ReactAria from "react-aria";
import * as ReactRouter from "react-router";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as ReactRouterDom from "react-router-dom";
import * as JsxRuntime from "react/jsx-runtime";

function urlToRoute(url) {
  let queryString = url.query;
  let tmp = queryString === "" ? "" : "?" + queryString;
  return url.pathname + tmp;
}

function pathFromPathname(pathname) {
  switch (pathname) {
    case "" :
    case "/" :
      return [];
    default:
      let raw = pathname.slice(1);
      let match = raw.charAt(raw.length - 1 | 0);
      let raw$1 = match === "/" ? raw.slice(0, -1) : raw;
      return raw$1.split("/");
  }
}

let match = Env.context();

let history = match === "test" ? History.createMemoryHistory(undefined) : History.createBrowserHistory();

function useRouter() {
  return React.useContext(ReactRouter.__RouterContext);
}

function useUrl() {
  let match = React.useContext(ReactRouter.__RouterContext);
  let location = match.location;
  return {
    pathname: location.pathname,
    path: pathFromPathname(location.pathname),
    query: location.search.slice(1),
    state: location.state
  };
}

function useNavigate() {
  let match = React.useContext(ReactRouter.__RouterContext);
  let history = match.history;
  return (options, pathname) => {
    let replace = Stdlib_Option.getOr(Stdlib_Option.flatMap(options, options => options.replace), false);
    let state = Stdlib_Option.flatMap(options, options => options.state);
    let pushAction = replace ? history.replace : history.push;
    pushAction(pathname, state);
  };
}

function useGoBack() {
  let match = React.useContext(ReactRouter.__RouterContext);
  let history = match.history;
  let historyIndex = history.index;
  let canGoBack = historyIndex !== undefined ? historyIndex > 0 : history.length > 1;
  let onGoBack = () => history.goBack();
  return [
    canGoBack,
    onGoBack
  ];
}

function openRoute(route) {
  history.replace(route, undefined);
}

function openNewTabRoute(route) {
  window.open(route);
}

function closeBrowserTab() {
  window.close();
}

function toRoute(route) {
  return {
    TAG: "Route",
    _0: route
  };
}

function toUrl(href) {
  return {
    TAG: "Url",
    _0: href
  };
}

function Navigation$Link(props) {
  let className = props.className;
  let __disabled = props.disabled;
  let __openNewTab = props.openNewTab;
  let to = props.to;
  let children = props.children;
  let openNewTab = __openNewTab !== undefined ? __openNewTab : false;
  let disabled = __disabled !== undefined ? __disabled : false;
  let tmp;
  switch (to.TAG) {
    case "Route" :
    case "RouteWithQueryString" :
      tmp = undefined;
      break;
    case "Url" :
      tmp = to._0.href;
      break;
  }
  let defaultProps_target = openNewTab ? "_blank" : "_self";
  let defaultProps_isDisabled = disabled;
  let defaultProps_onPress = props.onPress;
  let defaultProps = {
    href: tmp,
    target: defaultProps_target,
    isDisabled: defaultProps_isDisabled,
    onPress: defaultProps_onPress
  };
  let props$1 = Stdlib_Option.getOr(props.ariaProps, defaultProps);
  let match = ReactAria.useLink(props$1, undefined);
  let linkProps = match.linkProps;
  if (disabled) {
    let newrecord = {...linkProps};
    return JsxRuntime.jsx("span", (newrecord.role = "link", newrecord.className = className, newrecord.children = children, newrecord));
  }
  switch (to.TAG) {
    case "Route" :
      let pathname = to._0;
      let replace = pathname === "";
      let newrecord$1 = {...linkProps};
      return JsxRuntime.jsx(ReactRouterDom.Link, (newrecord$1.className = className, newrecord$1.replace = replace, newrecord$1.to = {
        pathname: pathname
      }, newrecord$1.children = children, newrecord$1));
    case "RouteWithQueryString" :
      let pathname$1 = to._0;
      let replace$1 = pathname$1 === "";
      let newrecord$2 = {...linkProps};
      return JsxRuntime.jsx(ReactRouterDom.Link, (newrecord$2.className = className, newrecord$2.replace = replace$1, newrecord$2.to = {
        pathname: pathname$1,
        search: to._1
      }, newrecord$2.children = children, newrecord$2));
    case "Url" :
      let newrecord$3 = {...linkProps};
      return JsxRuntime.jsx("a", (newrecord$3.className = className, newrecord$3.children = children, newrecord$3));
  }
}

let Link = {
  toRoute: toRoute,
  toUrl: toUrl,
  make: Navigation$Link
};

function Navigation$Provider(props) {
  return JsxRuntime.jsx(ReactRouter.Router, {
    children: props.children,
    history: Stdlib_Option.getOr(props.history, history)
  });
}

let Provider = {
  make: Navigation$Provider
};

let make = React.memo(props => {
  let shouldBlockOnRouteChange = props.shouldBlockOnRouteChange;
  let message = props.message;
  let match = React.useContext(ReactRouter.__RouterContext);
  let location = match.location;
  let history = match.history;
  let unblock = React.useRef(undefined);
  let handleUnload = React.useCallback(domEvent => {
    if (shouldBlockOnRouteChange(location.pathname)) {
      domEvent.returnValue = message;
      return;
    }
  }, [
    location.pathname,
    shouldBlockOnRouteChange
  ]);
  React.useEffect(() => {
    unblock.current = history.block((location, _action) => {
      if (shouldBlockOnRouteChange(location.pathname)) {
        return message;
      }
    });
    return () => {
      let unblock$1 = unblock.current;
      if (unblock$1 !== undefined) {
        return unblock$1();
      }
    };
  }, [shouldBlockOnRouteChange]);
  React.useEffect(() => {
    window.addEventListener("beforeunload", handleUnload);
    return () => {
      window.removeEventListener("beforeunload", handleUnload);
    };
  }, [handleUnload]);
  return null;
});

let Prompt = {
  make: make
};

function Navigation$Redirect(props) {
  return JsxRuntime.jsx(ReactRouterDom.Redirect, {
    to: {
      pathname: props.route
    }
  });
}

let Redirect = {
  make: Navigation$Redirect
};

function Navigation$ConnectReactAriaProvider(props) {
  let navigate = useNavigate();
  return JsxRuntime.jsx(ReactAria.RouterProvider, {
    children: props.children,
    navigate: (href, routerOptions) => navigate(routerOptions, href)
  });
}

let ConnectReactAriaProvider = {
  make: Navigation$ConnectReactAriaProvider
};

export {
  urlToRoute,
  pathFromPathname,
  history,
  useRouter,
  useUrl,
  useNavigate,
  useGoBack,
  openRoute,
  openNewTabRoute,
  closeBrowserTab,
  Link,
  Provider,
  Prompt,
  Redirect,
  ConnectReactAriaProvider,
}
/* match Not a pure module */
